import InviteStatusBadge from '@/components/badges/InviteStatusBadge';
import { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { InviteTableRowType } from '../types';

const InviteStatusHeader: FC = () => {
  const { t } = useTranslation('settings');
  return <>{t('workspaceUsers.columns.status')}</>;
};

export const getInviteStatusColumn = (): ColumnDef<InviteTableRowType> => {
  return {
    accessorKey: 'status',
    header: InviteStatusHeader,
    cell: ({ row }) => (
      <div className='text-sm'>
        <InviteStatusBadge status={row.original.status} />
      </div>
    ),
  };
};
